import React from 'react';

/** redux **/
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as selectors from './redux/reducer';

import Loader from '../../components/Loader';

// components
import Hero from '../../components/Hero.js';
import MainListicle from '../../components/MainListicle.js';
import ContributorCard from '../../components/ContributorCard.js';
import BoostCard from '../../components/BoostCard.js';
import CardsSlider from '../../components/CardsSlider';
import SecondaryListicle from '../../components/SecondaryListicle';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { storeCityName } from 'utils/'

const styles = theme => ({
  featuredContainer: {
    padding: '20px',
    textAlign: 'left'
  },
  relatedContainer: {
    marginTop: '-10px'
  }
});

class Listicle extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  componentWillMount(){
    storeCityName(this.props.match.params.cityname);
  }
  componentDidMount() {
    let listicle = this.props.match.params.listiclename;
    this.props.dispatch(actions.getData(listicle));
  }
  render() {
    console.log(this.props);
    const { classes, history, loading, listicle, featured, related } = this.props;
    if (loading) {
      return (
        <Loader />
      )
    }
    else {
      let locationArray = listicle.eateryList.map((eaterySum, i) => {
        return {
          title: eaterySum.eatery.name,
          lat: eaterySum.eatery.location.latitude,
          lng: eaterySum.eatery.location.longitude
        }
      })
      const owner = listicle.owner ? listicle.owner : {};
      const ownerID = owner.id ? owner.id : '';
      const checkingCuisineExpt = owner.cuisinesOfExpertise ? owner.cuisinesOfExpertise : [];
      const cuisinesOfExpert = checkingCuisineExpt ? checkingCuisineExpt.map(cuis => cuis.name) : [];
      return (
        <div>
          <Hero {...{ title: listicle.title, lastUpdated: "last updated", imageUrl: listicle.image.uri, oneLiner: listicle.summary }} />
          <SecondaryListicle {...{ data: locationArray }} />
          {
            listicle.eateryList.map((eateryItem, i) => {
              return <div key={"eateryItem" + i}>
                <MainListicle {...{ eateryItem }} />
                <hr />
              </div>
            })
          }
          {owner.displayName || owner.name ? (
            <ContributorCard
              {...{
                name: owner.displayName ? owner.displayName : owner.name,
                img: owner.profilePic
                  ? owner.profilePic.uri
                  : '/icons/user.png',
                oneLineDesc: owner.userProfile.bio ? owner.userProfile.bio : '',
                cuisines: cuisinesOfExpert ? cuisinesOfExpert : '',
                following: true,
                id: ownerID,
              }}
            />
          ) : (
              ''
            )
          }
          {
            // eatery.contributions[0].owner ? (
            //   <SeeAllContributors contributors={eatery.contributions} />
            // ) : (
            //   ''
            // )
          }
          <BoostCard comments={listicle.comments} />
          <div className={classes.featuredContainer}>
            <Typography variant="body2">FEATURED</Typography>
            <br />
            <CardsSlider history={history} cards={featured} />
            <br />
            <br />
            <div className={classes.relatedContainer}>
              <Typography variant="body2">RELATED</Typography>
              <br />
            </div>
            <CardsSlider history={history} cards={related} />
          </div>
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  return selectors.getAllValues(state);
}

export default connect(mapStateToProps)(withStyles(styles)(Listicle));
